const _tableImport = {
    excleHead: [
        // status
        {
            title: "Status Import",
            dataIndex: "status_import",
            scopedSlots: { customRender: "status_import" },
            width: 100,
            // fixed: "left",
            className: "center-colum column-header-fix-data-s",
        },
        // status detail
        {
        title: "Status Import Detail",
        dataIndex: "status_detail",
        scopedSlots: { customRender: "status_detail" },
        width: 150,
        // fixed: "left",
        className: "center-colum column-header-fix-data-s",
        },        
        {
            title: "Student_ID",
            dataIndex: "student_id",
            key: "student_id",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Address",
            dataIndex: "address",
            scopedSlots: { customRender: "address" },
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Email",
            dataIndex: "email",
            scopedSlots: { customRender: "email" },
            // fixed: "left",
            width: 150,
            className: "center-colum column-header-fix-data",
        },{
            title: "Home Phone",
            dataIndex: "phone_home",
            width: 100,
            scopedSlots: { customRender: "phone_home" },
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Phone",
            dataIndex: "phone_number",
            width: 100,
            scopedSlots: { customRender: "phone_home" },
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Facebook",
            dataIndex: "social_facebook",
            width: 80,
            scopedSlots: { customRender: "social_facebook" },
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "IG",
            dataIndex: "social_instagram",
            width: 80,
            scopedSlots: { customRender: "social_instagram" },
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Unsubscribe",
            dataIndex: "subscribe ",
            scopedSlots: { customRender: "subscribe" },
            // fixed: "left",
            width: 80,
            className: "center-colum column-header-fix-data",
        },
    ],
}

export default _tableImport;
